export const sendEvent = ({ type, name }) => {
    try {
        if (!window?.ewt?.track) return;
        window.ewt.track({ name, type });
    } catch (e) {
        console.log(e);
    }
};

export default {
    sendEvent
};